import {
  Drawer,
  Box,
  Typography,
  Stack,
  TextField,
  Button
} from "@mui/material";

import { useEffect, useState } from "react";

import axios from "axios";
import PhotosManager from "./PhotoManager";
import { createRoom } from "../Inventory/inventoryService";

export default function RoomsDrawer({ open, setOpen, room, refreshRooms, hotelId }) {

  const [form, setForm] = useState({
  title: "",
  desc: "",
  maxPeople: 1,
  price: 0,
  inventory: 1,
  photos: []
});

useEffect(() => {

  if (room) {

    setForm({
      title: room.title,
      desc: room.desc,
      maxPeople: room.maxPeople,
      price: room.price,
      photos: room.photos || []
    });

  } else {

    setForm({
      title: "",
      desc: "",
      maxPeople: 1,
      price: 0,
      inventory: 1,
      photos: []
    });

  }

}, [room]);
  

const handleSave = async () => {

  try {

    if (room) {

      await axios.put(
        `https://api.komorotel.com/api/rooms/${room._id}`,
        form,
        { withCredentials: true }
      );

    } else {

      await createRoom(hotelId, form);

    }

    refreshRooms();
    setOpen(false);

  } catch (err) {

    console.error(err);

  }

};

  return (

    <Drawer
      anchor="right"
      open={open}
      onClose={() => setOpen(false)}
    >

      <Box sx={{ width: 420, p: 4 }}>

        <Typography variant="h6" mb={3}>
          Modifier la chambre
        </Typography>

        <Stack spacing={3}>

          <TextField
            label="Nom de la chambre"
            value={form.title}
            onChange={(e) =>
              setForm({ ...form, title: e.target.value })
            }
            fullWidth
          />

          <TextField
            label="Description"
            value={form.desc}
            onChange={(e) =>
              setForm({ ...form, desc: e.target.value })
            }
            fullWidth
          />

          <TextField
            label="Capacité max"
            type="number"
            value={form.maxPeople}
            onChange={(e) =>
              setForm({ ...form, maxPeople: e.target.value })
            }
            fullWidth
          />

          <TextField
            label="Prix de base (€)"
            type="number"
            value={form.price}
            onChange={(e) =>
                setForm({ ...form, price: Number(e.target.value) })
            }
            fullWidth
            />
            {!room && (
            <TextField
                label="Stock initial"
                type="number"
                value={form.inventory}
                onChange={(e) =>
                setForm({ ...form, inventory: e.target.value })
                }
                fullWidth
            />
            )}

          {/* UPLOAD PHOTOS */}

          <PhotosManager
            photos={form.photos}
            setPhotos={(photos) =>
                setForm({ ...form, photos })
            }
            />

          <Button
            variant="contained"
            onClick={handleSave}
          >
           
            {room ? "Modifier la chambre" : "Nouvelle chambre"}
           
          </Button>

        </Stack>

      </Box>

    </Drawer>
  );
}